"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarSplitMenuButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../../theme/utils/useTheme");
var _useHovered = require("../../../../util/useHovered");
var _useFocusElement = require("../../hooks/useFocusElement");
var _LeftSplitButton = require("../../styled/LeftSplitButton");
var _ToolbarSplitMenuButtonWrapper = require("../../styled/ToolbarSplitMenuButtonWrapper");
var _RightSplitMenuButton = require("./RightSplitMenuButton");
const ToolbarSplitMenuButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    dropdownTooltipText,
    children,
    menuId: providedMenuId,
    isChecked,
    clientId,
    className,
    id: providedId,
    menuRef,
    dropdownRef,
    dropdownLabel,
    onMouseEnter: providedOnMouseEnter,
    onMouseLeave: providedOnMouseLeave,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const wrapperRef = (0, _react.useRef)(null);
  const {
    isHovered,
    onMouseEnter,
    onMouseLeave
  } = (0, _useHovered.useHovered)({
    onMouseEnter: providedOnMouseEnter,
    onMouseLeave: providedOnMouseLeave
  });
  const rootId = (0, _react.useMemo)(() => providedId ?? (0, _lodestarUtils.genId)("tbsmb-root"), [providedId]);
  const menuId = (0, _react.useMemo)(() => providedMenuId ?? (0, _lodestarUtils.genId)("tbsmb-menu"), [providedMenuId]);
  const focusProps = (0, _useFocusElement.useFocusElement)({
    targetRef: ref,
    onFocus: rest.onFocus,
    onKeyDown: rest.onKeyDown,
    onBlur: rest.onBlur
  });
  const switchProps = isChecked !== undefined ? {
    role: "switch",
    "aria-checked": isChecked
  } : null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ToolbarSplitMenuButtonWrapper.ToolbarSplitMenuButtonWrapper, {
    ref: wrapperRef,
    "data-client-id": clientId,
    className: className,
    id: rootId
  }, /*#__PURE__*/_react.default.createElement(_LeftSplitButton.LeftSplitButton, (0, _extends2.default)({}, rest, switchProps, focusProps, {
    isChecked: isChecked,
    isHovered: isHovered,
    isOpen: isOpen,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    themeMode: themeMode,
    toolbarButtonType: "ToolbarLeftSplitButton"
  })), /*#__PURE__*/_react.default.createElement(_RightSplitMenuButton.RightSplitMenuButton, {
    isHovered: isHovered,
    tooltipPlacement: rest.tooltipPlacement,
    isDisabled: rest.isDisabled,
    isChecked: isChecked,
    label: dropdownLabel || rest.label,
    menuId: menuId,
    targetRef: wrapperRef,
    tooltipText: dropdownTooltipText,
    menuRef: menuRef,
    ref: dropdownRef,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onMenuTrigger: setIsOpen
  }, children)));
});
exports.ToolbarSplitMenuButton = ToolbarSplitMenuButton;
ToolbarSplitMenuButton.displayName = "ToolbarSplitMenuButton";
//# sourceMappingURL=ToolbarSplitMenuButton.js.map